// TODO rename plural constants to singular form.
import keyMirror from 'key-mirror';
import { deepFreeze } from '@mw/helpers';

export const Country = [
  { code: 'AD', country: 'Andorra', phoneCode: '376' },
  { code: 'AE', country: 'United Arab Emirates', phoneCode: '971' },
  { code: 'AF', country: 'Afghanistan', phoneCode: '93' },
  { code: 'AG', country: 'Antigua and Barbuda', phoneCode: '1268' },
  { code: 'AI', country: 'Anguilla', phoneCode: '1264' },
  { code: 'AL', country: 'Albania', phoneCode: '355' },
  { code: 'AM', country: 'Armenia', phoneCode: '374' },
  { code: 'AO', country: 'Angola', phoneCode: '244' },
  { code: 'AQ', country: 'Antarctica', phoneCode: '672' },
  { code: 'AR', country: 'Argentina', phoneCode: '54' },
  { code: 'AS', country: 'American Samoa', phoneCode: '1684' },
  { code: 'AT', country: 'Austria', phoneCode: '43' },
  { code: 'AU', country: 'Australia', phoneCode: '61', suggested: true },
  { code: 'AW', country: 'Aruba', phoneCode: '297' },
  { code: 'AX', country: 'Alland Islands', phoneCode: '358' },
  { code: 'AZ', country: 'Azerbaijan', phoneCode: '994' },
  { code: 'BA', country: 'Bosnia and Herzegovina', phoneCode: '387' },
  { code: 'BB', country: 'Barbados', phoneCode: '1246' },
  { code: 'BD', country: 'Bangladesh', phoneCode: '880' },
  { code: 'BE', country: 'Belgium', phoneCode: '32' },
  { code: 'BF', country: 'Burkina Faso', phoneCode: '226' },
  { code: 'BG', country: 'Bulgaria', phoneCode: '359' },
  { code: 'BH', country: 'Bahrain', phoneCode: '973' },
  { code: 'BI', country: 'Burundi', phoneCode: '257' },
  { code: 'BJ', country: 'Benin', phoneCode: '229' },
  { code: 'BL', country: 'Saint Barthelemy', phoneCode: '590' },
  { code: 'BM', country: 'Bermuda', phoneCode: '1441' },
  { code: 'BN', country: 'Brunei Darussalam', phoneCode: '673' },
  { code: 'BO', country: 'Bolivia', phoneCode: '591' },
  { code: 'BR', country: 'Brazil', phoneCode: '55' },
  { code: 'BS', country: 'Bahamas', phoneCode: '1242' },
  { code: 'BT', country: 'Bhutan', phoneCode: '975' },
  { code: 'BV', country: 'Bouvet Island', phoneCode: '47' },
  { code: 'BW', country: 'Botswana', phoneCode: '267' },
  { code: 'BY', country: 'Belarus', phoneCode: '375' },
  { code: 'BZ', country: 'Belize', phoneCode: '501' },
  { code: 'CA', country: 'Canada', phoneCode: '1', suggested: true },
  { code: 'CC', country: 'Cocos (Keeling) Islands', phoneCode: '61' },
  { code: 'CD', country: 'Congo, Republic of the', phoneCode: '242' },
  { code: 'CF', country: 'Central African Republic', phoneCode: '236' },
  {
    code: 'CG',
    country: 'Congo, Democratic Republic of the',
    phoneCode: '243',
  },
  { code: 'CH', country: 'Switzerland', phoneCode: '41' },
  { code: 'CI', country: "Cote d'Ivoire", phoneCode: '225' },
  { code: 'CK', country: 'Cook Islands', phoneCode: '682' },
  { code: 'CL', country: 'Chile', phoneCode: '56' },
  { code: 'CM', country: 'Cameroon', phoneCode: '237' },
  { code: 'CN', country: 'China', phoneCode: '86' },
  { code: 'CO', country: 'Colombia', phoneCode: '57' },
  { code: 'CR', country: 'Costa Rica', phoneCode: '506' },
  { code: 'CU', country: 'Cuba', phoneCode: '53' },
  { code: 'CV', country: 'Cape Verde', phoneCode: '238' },
  { code: 'CW', country: 'Curacao', phoneCode: '599' },
  { code: 'CX', country: 'Christmas Island', phoneCode: '61' },
  { code: 'CY', country: 'Cyprus', phoneCode: '357' },
  { code: 'CZ', country: 'Czech Republic', phoneCode: '420' },
  { code: 'DE', country: 'Germany', phoneCode: '49', suggested: true },
  { code: 'DJ', country: 'Djibouti', phoneCode: '253' },
  { code: 'DK', country: 'Denmark', phoneCode: '45' },
  { code: 'DM', country: 'Dominica', phoneCode: '1767' },
  { code: 'DO', country: 'Dominican Republic', phoneCode: '1-809' },
  { code: 'DZ', country: 'Algeria', phoneCode: '213' },
  { code: 'EC', country: 'Ecuador', phoneCode: '593' },
  { code: 'EE', country: 'Estonia', phoneCode: '372' },
  { code: 'EG', country: 'Egypt', phoneCode: '20' },
  { code: 'EH', country: 'Western Sahara', phoneCode: '212' },
  { code: 'ER', country: 'Eritrea', phoneCode: '291' },
  { code: 'ES', country: 'Spain', phoneCode: '34' },
  { code: 'ET', country: 'Ethiopia', phoneCode: '251' },
  { code: 'FI', country: 'Finland', phoneCode: '358' },
  { code: 'FJ', country: 'Fiji', phoneCode: '679' },
  { code: 'FK', country: 'Falkland Islands (Malvinas)', phoneCode: '500' },
  { code: 'FM', country: 'Micronesia, Federated States of', phoneCode: '691' },
  { code: 'FO', country: 'Faroe Islands', phoneCode: '298' },
  { code: 'FR', country: 'France', phoneCode: '33', suggested: true },
  { code: 'GA', country: 'Gabon', phoneCode: '241' },
  { code: 'GB', country: 'United Kingdom', phoneCode: '44' },
  { code: 'GD', country: 'Grenada', phoneCode: '1473' },
  { code: 'GE', country: 'Georgia', phoneCode: '995' },
  { code: 'GF', country: 'French Guiana', phoneCode: '594' },
  { code: 'GG', country: 'Guernsey', phoneCode: '44' },
  { code: 'GH', country: 'Ghana', phoneCode: '233' },
  { code: 'GI', country: 'Gibraltar', phoneCode: '350' },
  { code: 'GL', country: 'Greenland', phoneCode: '299' },
  { code: 'GM', country: 'Gambia', phoneCode: '220' },
  { code: 'GN', country: 'Guinea', phoneCode: '224' },
  { code: 'GP', country: 'Guadeloupe', phoneCode: '590' },
  { code: 'GQ', country: 'Equatorial Guinea', phoneCode: '240' },
  { code: 'GR', country: 'Greece', phoneCode: '30' },
  {
    code: 'GS',
    country: 'South Georgia and the South Sandwich Islands',
    phoneCode: '500',
  },
  { code: 'GT', country: 'Guatemala', phoneCode: '502' },
  { code: 'GU', country: 'Guam', phoneCode: '1671' },
  { code: 'GW', country: 'Guinea-Bissau', phoneCode: '245' },
  { code: 'GY', country: 'Guyana', phoneCode: '592' },
  { code: 'HK', country: 'Hong Kong', phoneCode: '852' },
  {
    code: 'HM',
    country: 'Heard Island and McDonald Islands',
    phoneCode: '672',
  },
  { code: 'HN', country: 'Honduras', phoneCode: '504' },
  { code: 'HR', country: 'Croatia', phoneCode: '385' },
  { code: 'HT', country: 'Haiti', phoneCode: '509' },
  { code: 'HU', country: 'Hungary', phoneCode: '36' },
  { code: 'ID', country: 'Indonesia', phoneCode: '62' },
  { code: 'IE', country: 'Ireland', phoneCode: '353' },
  { code: 'IL', country: 'Israel', phoneCode: '972' },
  { code: 'IM', country: 'Isle of Man', phoneCode: '44' },
  { code: 'IN', country: 'India', phoneCode: '91' },
  { code: 'IO', country: 'British Indian Ocean Territory', phoneCode: '246' },
  { code: 'IQ', country: 'Iraq', phoneCode: '964' },
  { code: 'IR', country: 'Iran, Islamic Republic of', phoneCode: '98' },
  { code: 'IS', country: 'Iceland', phoneCode: '354' },
  { code: 'IT', country: 'Italy', phoneCode: '39' },
  { code: 'JE', country: 'Jersey', phoneCode: '44' },
  { code: 'JM', country: 'Jamaica', phoneCode: '1876' },
  { code: 'JO', country: 'Jordan', phoneCode: '962' },
  { code: 'JP', country: 'Japan', phoneCode: '81', suggested: true },
  { code: 'KE', country: 'Kenya', phoneCode: '254' },
  { code: 'KG', country: 'Kyrgyzstan', phoneCode: '996' },
  { code: 'KH', country: 'Cambodia', phoneCode: '855' },
  { code: 'KI', country: 'Kiribati', phoneCode: '686' },
  { code: 'KM', country: 'Comoros', phoneCode: '269' },
  { code: 'KN', country: 'Saint Kitts and Nevis', phoneCode: '1869' },
  {
    code: 'KP',
    country: "Korea, Democratic People's Republic of",
    phoneCode: '850',
  },
  { code: 'KR', country: 'Korea, Republic of', phoneCode: '82' },
  { code: 'KW', country: 'Kuwait', phoneCode: '965' },
  { code: 'KY', country: 'Cayman Islands', phoneCode: '1345' },
  { code: 'KZ', country: 'Kazakhstan', phoneCode: '7' },
  { code: 'LA', country: "Lao People's Democratic Republic", phoneCode: '856' },
  { code: 'LB', country: 'Lebanon', phoneCode: '961' },
  { code: 'LC', country: 'Saint Lucia', phoneCode: '1758' },
  { code: 'LI', country: 'Liechtenstein', phoneCode: '423' },
  { code: 'LK', country: 'Sri Lanka', phoneCode: '94' },
  { code: 'LR', country: 'Liberia', phoneCode: '231' },
  { code: 'LS', country: 'Lesotho', phoneCode: '266' },
  { code: 'LT', country: 'Lithuania', phoneCode: '370' },
  { code: 'LU', country: 'Luxembourg', phoneCode: '352' },
  { code: 'LV', country: 'Latvia', phoneCode: '371' },
  { code: 'LY', country: 'Libya', phoneCode: '218' },
  { code: 'MA', country: 'Morocco', phoneCode: '212' },
  { code: 'MC', country: 'Monaco', phoneCode: '377' },
  { code: 'MD', country: 'Moldova, Republic of', phoneCode: '373' },
  { code: 'ME', country: 'Montenegro', phoneCode: '382' },
  { code: 'MF', country: 'Saint Martin (French part)', phoneCode: '590' },
  { code: 'MG', country: 'Madagascar', phoneCode: '261' },
  { code: 'MH', country: 'Marshall Islands', phoneCode: '692' },
  {
    code: 'MK',
    country: 'Macedonia, the Former Yugoslav Republic of',
    phoneCode: '389',
  },
  { code: 'ML', country: 'Mali', phoneCode: '223' },
  { code: 'MM', country: 'Myanmar', phoneCode: '95' },
  { code: 'MN', country: 'Mongolia', phoneCode: '976' },
  { code: 'MO', country: 'Macao', phoneCode: '853' },
  { code: 'MP', country: 'Northern Mariana Islands', phoneCode: '1670' },
  { code: 'MQ', country: 'Martinique', phoneCode: '596' },
  { code: 'MR', country: 'Mauritania', phoneCode: '222' },
  { code: 'MS', country: 'Montserrat', phoneCode: '1-664' },
  { code: 'MT', country: 'Malta', phoneCode: '356' },
  { code: 'MU', country: 'Mauritius', phoneCode: '230' },
  { code: 'MV', country: 'Maldives', phoneCode: '960' },
  { code: 'MW', country: 'Malawi', phoneCode: '265' },
  { code: 'MX', country: 'Mexico', phoneCode: '52' },
  { code: 'MY', country: 'Malaysia', phoneCode: '60' },
  { code: 'MZ', country: 'Mozambique', phoneCode: '258' },
  { code: 'NA', country: 'Namibia', phoneCode: '264' },
  { code: 'NC', country: 'New Caledonia', phoneCode: '687' },
  { code: 'NE', country: 'Niger', phoneCode: '227' },
  { code: 'NF', country: 'Norfolk Island', phoneCode: '672' },
  { code: 'NG', country: 'Nigeria', phoneCode: '234' },
  { code: 'NI', country: 'Nicaragua', phoneCode: '505' },
  { code: 'NL', country: 'Netherlands', phoneCode: '31' },
  { code: 'NO', country: 'Norway', phoneCode: '47' },
  { code: 'NP', country: 'Nepal', phoneCode: '977' },
  { code: 'NR', country: 'Nauru', phoneCode: '674' },
  { code: 'NU', country: 'Niue', phoneCode: '683' },
  { code: 'NZ', country: 'New Zealand', phoneCode: '64' },
  { code: 'OM', country: 'Oman', phoneCode: '968' },
  { code: 'PA', country: 'Panama', phoneCode: '507' },
  { code: 'PE', country: 'Peru', phoneCode: '51' },
  { code: 'PF', country: 'French Polynesia', phoneCode: '689' },
  { code: 'PG', country: 'Papua New Guinea', phoneCode: '675' },
  { code: 'PH', country: 'Philippines', phoneCode: '63' },
  { code: 'PK', country: 'Pakistan', phoneCode: '92' },
  { code: 'PL', country: 'Poland', phoneCode: '48' },
  { code: 'PM', country: 'Saint Pierre and Miquelon', phoneCode: '508' },
  { code: 'PN', country: 'Pitcairn', phoneCode: '870' },
  { code: 'PR', country: 'Puerto Rico', phoneCode: '1' },
  { code: 'PS', country: 'Palestine, State of', phoneCode: '970' },
  { code: 'PT', country: 'Portugal', phoneCode: '351' },
  { code: 'PW', country: 'Palau', phoneCode: '680' },
  { code: 'PY', country: 'Paraguay', phoneCode: '595' },
  { code: 'QA', country: 'Qatar', phoneCode: '974' },
  { code: 'RE', country: 'Reunion', phoneCode: '262' },
  { code: 'RO', country: 'Romania', phoneCode: '40' },
  { code: 'RS', country: 'Serbia', phoneCode: '381' },
  { code: 'RU', country: 'Russian Federation', phoneCode: '7' },
  { code: 'RW', country: 'Rwanda', phoneCode: '250' },
  { code: 'SA', country: 'Saudi Arabia', phoneCode: '966' },
  { code: 'SB', country: 'Solomon Islands', phoneCode: '677' },
  { code: 'SC', country: 'Seychelles', phoneCode: '248' },
  { code: 'SD', country: 'Sudan', phoneCode: '249' },
  { code: 'SE', country: 'Sweden', phoneCode: '46' },
  { code: 'SG', country: 'Singapore', phoneCode: '65' },
  { code: 'SH', country: 'Saint Helena', phoneCode: '290' },
  { code: 'SI', country: 'Slovenia', phoneCode: '386' },
  { code: 'SJ', country: 'Svalbard and Jan Mayen', phoneCode: '47' },
  { code: 'SK', country: 'Slovakia', phoneCode: '421' },
  { code: 'SL', country: 'Sierra Leone', phoneCode: '232' },
  { code: 'SM', country: 'San Marino', phoneCode: '378' },
  { code: 'SN', country: 'Senegal', phoneCode: '221' },
  { code: 'SO', country: 'Somalia', phoneCode: '252' },
  { code: 'SR', country: 'Suriname', phoneCode: '597' },
  { code: 'SS', country: 'South Sudan', phoneCode: '211' },
  { code: 'ST', country: 'Sao Tome and Principe', phoneCode: '239' },
  { code: 'SV', country: 'El Salvador', phoneCode: '503' },
  { code: 'SX', country: 'Sint Maarten (Dutch part)', phoneCode: '1721' },
  { code: 'SY', country: 'Syrian Arab Republic', phoneCode: '963' },
  { code: 'SZ', country: 'Swaziland', phoneCode: '268' },
  { code: 'TC', country: 'Turks and Caicos Islands', phoneCode: '1649' },
  { code: 'TD', country: 'Chad', phoneCode: '235' },
  { code: 'TF', country: 'French Southern Territories', phoneCode: '262' },
  { code: 'TG', country: 'Togo', phoneCode: '228' },
  { code: 'TH', country: 'Thailand', phoneCode: '66' },
  { code: 'TJ', country: 'Tajikistan', phoneCode: '992' },
  { code: 'TK', country: 'Tokelau', phoneCode: '690' },
  { code: 'TL', country: 'Timor-Leste', phoneCode: '670' },
  { code: 'TM', country: 'Turkmenistan', phoneCode: '993' },
  { code: 'TN', country: 'Tunisia', phoneCode: '216' },
  { code: 'TO', country: 'Tonga', phoneCode: '676' },
  { code: 'TR', country: 'Turkey', phoneCode: '90' },
  { code: 'TT', country: 'Trinidad and Tobago', phoneCode: '1-868' },
  { code: 'TV', country: 'Tuvalu', phoneCode: '688' },
  { code: 'TW', country: 'Taiwan, Province of China', phoneCode: '886' },
  { code: 'TZ', country: 'United Republic of Tanzania', phoneCode: '255' },
  { code: 'UA', country: 'Ukraine', phoneCode: '380' },
  { code: 'UG', country: 'Uganda', phoneCode: '256' },
  { code: 'US', country: 'United States', phoneCode: '1', suggested: true },
  { code: 'UY', country: 'Uruguay', phoneCode: '598' },
  { code: 'UZ', country: 'Uzbekistan', phoneCode: '998' },
  { code: 'VA', country: 'Holy See (Vatican City State)', phoneCode: '379' },
  {
    code: 'VC',
    country: 'Saint Vincent and the Grenadines',
    phoneCode: '1784',
  },
  { code: 'VE', country: 'Venezuela', phoneCode: '58' },
  { code: 'VG', country: 'British Virgin Islands', phoneCode: '1284' },
  { code: 'VI', country: 'US Virgin Islands', phoneCode: '1340' },
  { code: 'VN', country: 'Vietnam', phoneCode: '84' },
  { code: 'VU', country: 'Vanuatu', phoneCode: '678' },
  { code: 'WF', country: 'Wallis and Futuna', phoneCode: '681' },
  { code: 'WS', country: 'Samoa', phoneCode: '685' },
  { code: 'XK', country: 'Kosovo', phoneCode: '383' },
  { code: 'YE', country: 'Yemen', phoneCode: '967' },
  { code: 'YT', country: 'Mayotte', phoneCode: '262' },
  { code: 'ZA', country: 'South Africa', phoneCode: '27' },
  { code: 'ZM', country: 'Zambia', phoneCode: '260' },
  { code: 'ZW', country: 'Zimbabwe', phoneCode: '263' },
];

export const RcsCountries = [
  { code: 'BW', country: 'Botswana', phoneCode: '267' },
  { code: 'BR', country: 'Brazil', phoneCode: '55' },
  { code: 'BF', country: 'Burkina Faso', phoneCode: '226' },
  { code: 'CA', country: 'Canada', phoneCode: '1' },
  { code: 'CL', country: 'Chile', phoneCode: '56' },
  { code: 'CO', country: 'Colombia', phoneCode: '57' },
  { code: 'CR', country: 'Costa Rica', phoneCode: '506' },
  { code: 'EC', country: 'Ecuador', phoneCode: '593' },
  { code: 'SV', country: 'El Salvador', phoneCode: '503' },
  { code: 'FR', country: 'France', phoneCode: '33' },
  { code: 'GT', country: 'Guatemala', phoneCode: '502' },
  { code: 'HN', country: 'Honduras', phoneCode: '504' },
  { code: 'IN', country: 'India', phoneCode: '91' },
  { code: 'CI', country: 'Ivory Coast', phoneCode: '225' },
  { code: 'IT', country: 'Italy', phoneCode: '39' },
  { code: 'MX', country: 'Mexico', phoneCode: '52' },
  { code: 'NI', country: 'Nicaragua', phoneCode: '505' },
  { code: 'NG', country: 'Nigeria', phoneCode: '234' },
  { code: 'PA', country: 'Panama', phoneCode: '507' },
  { code: 'PY', country: 'Paraguay', phoneCode: '595' },
  { code: 'PE', country: 'Peru', phoneCode: '51' },
  { code: 'PL', country: 'Poland', phoneCode: '48' },
  { code: 'PH', country: 'Philippines', phoneCode: '63' },
  { code: 'PR', country: 'Puerto Rico', phoneCode: '1' },
  { code: 'SN', country: 'Senegal', phoneCode: '221' },
  { code: 'ES', country: 'Spain', phoneCode: '34' },
  { code: 'GB', country: 'United Kingdom', phoneCode: '44' },
  { code: 'UY', country: 'Uruguay', phoneCode: '598' },
  { code: 'US', country: 'United States', phoneCode: '1' },
];

export const RcsRegions = [
  { code: 'NA', label: 'North America' },
  { code: 'EU', label: 'Europe' },
  { code: 'AP', label: 'Asia Pacific' },
];

export const MavenirCategories = [
  'Education',
  'Entertainment',
  'Finance',
  'Food & Drinks',
  'Health & Fitness',
  'Home & Auto',
  'Lifestyle',
  'News',
  'Productivity',
  'Religion and Spirituality',
  'Shopping & Retail',
  'Sports',
  'Travel',
  'Others',
];

export const Region = [
  { code: 'NA', label: 'North America' },
  { code: 'EU', label: 'Europe' },
  { code: 'ME', label: 'Middle East' },
  { code: 'AP', label: 'Asia Pacific' },
];

export const AgentStatus = keyMirror({
  CREATED: null,
  ON_APPROVAL: null,
  ACTIVE: null,
  HOLD: null,
  REMOVED: null,
});

export const CustomerChatbotEnabledStatus = keyMirror({
  ENABLED_AUTO: null,
  ENABLED_MANUALLY: null,
  DISABLED_AUTO: null,
  DISABLED_MANUALLY: null,
});

export const CustomerSubscribeStatus = keyMirror({
  ACTIVE: null,
  CANCELLED: null,
});

export const ChannelStatus = keyMirror({
  INACTIVE: null,
  CREATED: null,
  HOLD: null,
  ON_APPROVAL: null,
  ACTIVE: null,
  REMOVED: null,
});

export const ChannelType = keyMirror({
  ECHO: null,
  SMS: null,
  RCS: null,
  WA: null,
  TG: null,
  VI: null,
  WECHAT: null,
});

export const Channel = [
  { code: ChannelType.ECHO, label: 'Echo' },
  { code: ChannelType.SMS, label: 'SMS' },
  { code: ChannelType.RCS, label: 'RCS' },
  { code: ChannelType.WA, label: 'WhatsApp' },
  { code: ChannelType.TG, label: 'Telegram' },
  { code: ChannelType.VI, label: 'Viber' },
  { code: ChannelType.WECHAT, label: 'WeChat' },
];

export const AgentProviders = {
  [ChannelType.ECHO]: 'ECHO',
  [ChannelType.RCS]: {
    MAVENIR: 'MAVENIR',
    RBM: 'RBM',
  },
  [ChannelType.SMS]: {
    IZONET: 'IZONET',
  },
  [ChannelType.WA]: {
    WHATSAPP: 'WHATSAPP',
    VONAGE: 'VONAGE',
    TYNTEC: 'TYNTEC',
    GUPSHUP: 'GUPSHUP',
  },
  [ChannelType.TG]: {
    TELEGRAM: 'TELEGRAM',
  },
  [ChannelType.VI]: {
    VIBER: 'VIBER',
    APIFON: 'APIFON',
    FORTYTWO: 'FORTYTWO',
  },
  [ChannelType.WECHAT]: {
    TENCENT: 'TENCENT',
  },
};

export const ContentTypes = keyMirror({
  VIDEO: null,
  VOICE: null,
  IMAGE: null,
  AUDIO: null,
  APPLICATION: null,
  TEXT: null,
  UNSPECIFIED: null,
});

export const Origin = keyMirror({
  AGENT: null,
  CUSTOMER: null,
  BOT: null,
});

export const CustomerStatus = keyMirror({
  ACTIVE: null,
  REMOVED: null,
});

export const CardOrientation = keyMirror({
  CARD_ORIENTATION_UNSPECIFIED: null,
  VERTICAL: null,
  HORIZONTAL: null,
});

export const CardThumbnailImageAlignment = keyMirror({
  THUMBNAIL_IMAGE_ALIGNMENT_UNSPECIFIED: null,
  LEFT: null,
  RIGHT: null,
});

export const CardWidth = keyMirror({
  CARD_WIDTH_UNSPECIFIED: null,
  SMALL: null,
  MEDIUM: null,
});

export const CardHeight = keyMirror({
  SHORT: null,
  MEDIUM: null,
  TALL: null,
});

export const CardHeightLimit = {
  [CardHeight.SHORT]: 168,
  [CardHeight.MEDIUM]: 264,
};

export const ImagePlaceholderPath = '/static/images/no-image-slide.webp';

export const KeywordEvents = keyMirror({
  OPT_OUT: null,
  HELP: null,
  JOIN: null,
});

export const EventTypes = {
  OPT_OUT: 'Opt-out',
  HELP: 'Help',
  JOIN: 'Join',
  WELCOME: 'Welcome',
};

export const MediaTypes = {
  IMAGE: 'image',
  FILE: 'file',
  VIDEO: 'video',
};

export const ChannelsToShow = [
  ChannelType.SMS,
  ChannelType.TG,
  ChannelType.WA,
  ChannelType.VI,
  ChannelType.RCS,
  ChannelType.WECHAT,
];

export const phoneValidationErrors = {
  NOT_A_NUMBER: 'Enter a phone number',
  TOO_SHORT: 'Phone number is too short',
  TOO_LONG: 'Phone number is too long',
  INVALID_LENGTH: 'Phone number should be valid',
  INVALID_COUNTRY: 'Phone number should contain a country code',
};

export const FormNames = {
  CREATE_WA_CHANNEL: 'createWAChannel',
  CREATE_TG_CHANNEL: 'createTGChannel',
  CREATE_SMS_CHANNEL: 'createSMSChannel',
  CREATE_VI_CHANNEL: 'createVIChannel',
  CREATE_RCS_CHANNEL: 'createRCSChannel',
  CREATE_WECHAT_CHANNEL: 'createWeChatChannel',
};

export const StickerCategoryContentType = keyMirror({
  STATIC: null,
  ANIMATED: null,
  VIDEO: null,
});

export const WhatsAppTemplateVariableErrors = {
  WHATSAPP_INVALID_BODY_VARIABLES_COUNT:
    'Only five variables can be added to a template',
  WHATSAPP_INVALID_HEADER_VARIABLES_COUNT:
    'Only one {{variable}} can be added to a header text',
  WHATSAPP_VARIABLES_SYNTAX_ERROR: 'Variables have syntax errors',
  WHATSAPP_BODY_VARIABLE_START_ERROR: `Body text message can't start with a variable`,
};

export const ALLOWED_MIME_TYPE_FOR_IMAGE_LIST = 'image/jpeg';

export const MediaTags = {
  VIDEO: 'video',
  DOCUMENT: 'document',
  IMAGE: 'img',
};

export const MessageWebhookStatus = keyMirror({
  SUCCESS: null,
  FAILURE: null,
});

export const ModalTypes = {
  IMAGE: 'IMAGE',
  DOCUMENT: 'DOCUMENT',
  WA_TEMPLATES: 'WA_TEMPLATES',
  IMAGE_GALLERY: 'IMAGE_GALLERY',
  SHORT_LINKS: 'SHORT_LINKS',
};

export const PermissionState = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
};

export const WATemplateCategories = deepFreeze(
  keyMirror({
    AUTHENTICATION: null,
    MARKETING: null,
    UTILITY: null,
  })
);
